const Component10 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  if (items.length !== 10) {
    return <div>Questo componente è progettato per 10 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const firstColumnItems = items.slice(0, 2);
  const secondColumnItem = items.slice(2, 4);
  const terzaColumnItem = items.slice(4, 6);
  const quartaColumnItem = items.slice(6, 8);
  const quintaColumnItem = items.slice(8, 10);

  const getItemClass = (item) => {
    const selected = selectedColor === item.id ? "selected-border" : "";
    const disabled = isOutOfStock(item) ? "disabled" : "";
    const none = item.id === "none" ? "grid-item-none" : "";
    return `${selected} ${disabled} ${none}`.trim();
  };

  const getItemStyle = (item) => {
    return {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px",
      height: "50%",
      color: "white",
      backgroundImage: `url("${item.bg}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: item?.id === "none" ? "60% auto" : "cover",
    };
  };

  const handleClick = (item) => {
    if (isOutOfStock(item)) return;
    handleSelection(selectedCategory, item.id);
  };

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Prima colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {firstColumnItems.map((item, index) => (
          <div
            key={`first-column-${index}`}
            onClick={() => handleClick(item)}
            className={`grid-item ${getItemClass(item)}`}
            style={getItemStyle(item)}
          ></div>
        ))}
      </div>

      {/* Seconda colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {secondColumnItem.map((item, index) => (
          <div
            key={`second-column-${index}`}
            onClick={() => handleClick(item)}
            className={`grid-item ${getItemClass(item)}`}
            style={getItemStyle(item)}
          ></div>
        ))}
      </div>

      {/* Terza colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {terzaColumnItem.map((item, index) => (
          <div
            key={`terza-column-${index}`}
            onClick={() => handleClick(item)}
            className={`grid-item ${getItemClass(item)}`}
            style={getItemStyle(item)}
          ></div>
        ))}
      </div>

      {/* Quarta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quartaColumnItem.map((item, index) => (
          <div
            key={`quarta-column-${index}`}
            onClick={() => handleClick(item)}
            className={`grid-item ${getItemClass(item)}`}
            style={getItemStyle(item)}
          ></div>
        ))}
      </div>

      {/* Quinta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quintaColumnItem.map((item, index) => (
          <div
            key={`quinta-column-${index}`}
            onClick={() => handleClick(item)}
            className={`grid-item ${getItemClass(item)}`}
            style={getItemStyle(item)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Component10;
